var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnowboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.9,
    cy: 16.7,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.7,65.5c-1.7-3-4.5-5.1-7.8-6c-1.5-0.4-3.1-0.5-4.7-0.4L88.1,31.1c-0.9-0.9-2.2-1.5-3.6-1.5H48.4l-13-13 c-2-2-5.3-2-7.3,0s-2,5.3,0,7.3l14.5,14.5c0.9,0.9,2.2,1.5,3.6,1.5h15.4v30.9h23.1V42.3l21.3,21.3L85,75.8H44.3 c-2.8,0-5.1,2.3-5.1,5.1v21.3L22,112.2c-3,1.7-5.1,4.5-6,7.8c-0.9,3.3-0.4,6.8,1.3,9.8c1.7,3,4.5,5.1,7.8,6 c1.1,0.3,2.2,0.4,3.4,0.4c2.2,0,4.4-0.6,6.5-1.7l89-51.4c3-1.7,5.1-4.5,6-7.8C130.9,72,130.4,68.5,128.7,65.5z M49.4,86.1h17.7 L49.4,96.4V86.1z M127.3,74.6c-0.7,2.6-2.4,4.8-4.8,6.2l-89.1,51.4c-2.4,1.4-5.1,1.7-7.7,1c-2.6-0.7-4.8-2.4-6.2-4.8 s-1.7-5.1-1-7.7c0.7-2.6,2.4-4.8,4.8-6.2l0,0l89-51.4c1.6-0.9,3.3-1.4,5.1-1.4c0.9,0,1.8,0.1,2.7,0.3c2.6,0.7,4.8,2.4,6.2,4.8 C127.7,69.3,128,72,127.3,74.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowboard);
export default __webpack_public_path__ + "static/media/snowboard.b03827a5dcd67300f03ec6abe8528a5e.svg";
export { ForwardRef as ReactComponent };